import React from "react";
import "./Hero.css";

import productImg from "./images/pps-hero-products.png";

const whatsappNumber = "918368305178";
const whatsappMessage = "Hi! I'd like to order Royal Utsav products";
const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

function Hero() {
  return (
    <section className="hero">
      <div className="hero-content">
        <div className="hero-image-container">
          <img
            src={productImg}
            alt="Royal Utsav Products"
            className="hero-products-image"
          />
        </div>

        <div className="hero-overlay">
          <h1>
            <span className="brand-gold">Royal Utsav</span>
          </h1>

          <p className="hero-subtitle">
            Homemade Hair Care & Roasted Makhana Snacks
          </p>

          <p className="hero-tagline">
            Truly Homemade, Truly Royal ✨<br />
            Honest ingredients, made in small batches.
          </p>

          <div className="hero-buttons">
            <a href="#catalog" className="hero-btn primary">
              Pricing
            </a>

            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="hero-btn secondary"
            >
              <svg
                className="whatsapp-icon"
                viewBox="0 0 32 32"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
              >
                <path d="M16.001 3C9.373 3 4 8.373 4 15c0 2.362.687 4.564 1.872 6.418L4 29l7.77-1.84A11.94 11.94 0 0 0 16.001 27C22.628 27 28 21.627 28 15S22.628 3 16.001 3zm0 21.818c-1.98 0-3.827-.55-5.404-1.505l-.387-.23-4.61 1.092 1.13-4.49-.253-.4A9.77 9.77 0 0 1 5.182 15c0-5.964 4.855-10.818 10.819-10.818S26.818 9.036 26.818 15 21.965 24.818 16.001 24.818zm5.978-8.14c-.328-.164-1.94-.957-2.24-1.066-.301-.109-.52-.164-.738.164-.219.328-.847 1.066-1.038 1.285-.191.219-.383.246-.71.082-.328-.164-1.386-.51-2.64-1.63-.976-.87-1.635-1.945-1.826-2.273-.191-.328-.02-.505.144-.668.148-.148.328-.383.492-.574.164-.191.219-.328.328-.547.109-.219.055-.41-.027-.574-.082-.164-.738-1.777-1.012-2.434-.267-.64-.539-.553-.738-.563l-.63-.012c-.219 0-.574.082-.874.41-.301.328-1.148 1.121-1.148 2.734s1.175 3.172 1.339 3.39c.164.219 2.313 3.531 5.605 4.953.783.338 1.393.54 1.869.691.785.25 1.5.215 2.065.13.63-.094 1.94-.793 2.213-1.559.273-.766.273-1.422.191-1.559-.082-.137-.301-.219-.629-.383z" />
              </svg>
              Order Now on WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
